<template>
  <div v-if="onlyShowDate" class="row">
    <div class="col">
      <div class="row">
        <div class="col-lg-3 lbl">
          <label>Entité:</label>
        </div>
        <div class="col-lg-9">
          <Dropdown
              class="input-width-100"
              v-model="entite"
              :options="entiteLibelles"
              optionValue="valeur"
              optionLabel="texte"
              v-on:keyup.enter="imprimer"
              scrollHeight="700px"
              :showClear="true"
          />
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row">
        <div class="col-lg-3 lbl">
          <label>Site d'origine:</label>
        </div>
        <div class="col-lg-9">
          <Dropdown
              class="input-width-100"
              v-model="site"
              :options="sitesLibelles"
              optionValue="valeur"
              optionLabel="texte"
              @:keyup.enter="imprimer"
              scrollHeight="205px"
              :showClear="true"
          />
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col-lg-3 lbl">
          <label>Du:</label>
        </div>
        <div class="col-lg-9">
          <CustomInputDate
              class="input-width-100"
              type="date"
              max="9999-12-31"
              v-model="dateDu"
              v-on:keyup.enter="imprimer"
          />
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row">
        <div class="col-lg-3 lbl">
          <label>Au:</label>
        </div>
        <div class="col-lg-9">
          <CustomInputDate
              class="input-width-100"
              type="date"
              max="9999-12-31"
              v-model="dateAu"
              v-on:keyup.enter="imprimer"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import axios from "axios";
import CustomInputDate from '../../Commun/CustomInputDate.vue'

export default {
  name: "CritereRechercheEspaceJeux",
  emits: ['imprimer'],
  components: {
    CustomInputDate
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  props: {
    onlyShowDate: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {

    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
  },
  data() {
    return {
      entite: null,
      site: null,
      dateDu: null,
      dateAu: null,

      entiteLibelles: [],
      sitesLibelles: [],

      critereRecherche: {},
    };
  },
  methods: {
    assignerListe(entiteDecision) {
      this.entiteLibelles = entiteDecision.entite.libelles;
      this.fondeLibelles = entiteDecision.fonde.libelles;
      this.$store.dispatch("dossier/obtenirSiteEntiteAction").then((res) => {
        this.entite = res.data.entite;
        this.site = res.data.site;
        this.dateDefault();
      });
    },
    dateDefault() {
      let dateDefaut = new Date();
      this.dateDu = this.$commun.formatDate(dateDefaut.setDate(dateDefaut.getDate() - 30));
      this.dateAu = this.$commun.formatDate(new Date());
    },
    imprimer() {
      this.$emit("imprimer");
    },
    getCriteresRecherche() {
      if (this.dateAu !== null && this.dateAu !== undefined) {
        this.critereRecherche.dateAu = new Date(this.dateAu);
      }
      if (this.dateDu !== null && this.dateDu !== undefined) {
        this.critereRecherche.dateDu = new Date(this.dateDu);
      }
      this.critereRecherche.entite = this.entite;
      this.critereRecherche.siteOrigine = this.site;

      return this.critereRecherche;
    }
  },
  watch: {
    entite: function (val) {
      if (val !== null && val !== undefined) {
        this.$store.dispatch("dossier/onChangeEntityAction", {
          libelleChange: 'Site',
          nouvelleValeur: [val]
        }).then((res) => {
          this.sitesLibelles = res.data;
        });
      }
    }
  }
}
</script>